export default "/images/d93d563308212ac1f7327e0f0d53b036.avif";